// removed by extract-text-webpack-plugin
module.exports = {"lenderListContainer":"lenderListContainer__fbfxJ","lenderHeading":"lenderHeading__1mhs6","lenderMerchantListDiv":"lenderMerchantListDiv__30t6q","lenderImage":"lenderImage__e9KsI"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVC/lenders/style.css
// module id = 8nqQ
// module chunks = 444